import React from 'react';

/** White panel with the brand border radius used across all pages. */
export default function PageCard({ children, className = '', as: Tag = 'section' }) {
    return (
        <Tag className={`rounded-xl border border-slate-200/90 bg-white overflow-hidden ${className}`}>
            {children}
        </Tag>
    );
}
